<template>
  <base-card
    :to="lift.is_redirectable ? null : { path: lift.path}"
    :href="lift.is_redirectable ? lift.url : null"
    :target="lift.is_redirectable ? '_blank' : null"
    :rel="lift.is_redirectable ? 'noreferrer' : null"
    class="middle-cta"
    :class="{'is-mobile': $vuetify.breakpoint.xsOnly}"
  >
    <tk-media :media="bannerMedia" :aspect-ratio="1">
      <v-layout fill-height align-center pa-5 v-if="lift.title">
        <v-flex xs12 text-xs-center>
          <h2 class="display-1 font-weight-bold shadow mb-2" v-html="title"></h2>
          <tk-btn v-if="btn_title" light outline color="white">{{ btn_title }}</tk-btn>
        </v-flex>
      </v-layout>
    </tk-media>
  </base-card>
</template>


<script>
export default {
  props: ["lift"],

  computed: {
    bannerMedia() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return this.lift.mobile_media || {};
      }
      return this.lift.desktop_media || {};
    },

    title() {
      return this.getLocalizedText("title");
    },

    btn_title() {
      return this.getLocalizedText("btn_title");
    }
  },

  methods: {
    getLocalizedText(item) {
      if (
        typeof this.lift[item] === "string" ||
        this.lift[item] instanceof String
      ) {
        return this.lift[item];
      }

      console.log("getLocalizedText", this.lift);

      // If text has localized
      const localizedText = this.lift[item][this.$i18n.locale];
      if (localizedText) return localizedText;

      // If not localized title return fallback
      switch (this.$i18n.locale) {
        case "en":
          return this.lift[item]["fi"] || this.lift[item]["se"];
        case "fi":
          return this.lift[item]["en"] || this.lift[item]["se"];
        case "se":
          return this.lift[item]["en"] || this.lift[item]["fi"];
      }

      return null;
    }
  }
};
</script>

<style lang="scss">
.middle-cta {
  .display-1 {
    color: #ffffff;
    max-width: 350px;
    margin: 0 auto;
  }

  .v-btn {
    border-radius: 0px;
    border-width: 1px;
    font-size: 0.8rem;
    min-width: 160px;
  }

  h2 {
    color: #fff;
  }

  &:hover {
    .v-btn {
      background-color: #000 !important;
      border-color: #000 !important;
      color: #fff !important;
    }
  }

  &.is-mobile {
    .v-btn {
      background-color: #fff !important;
      color: #000 !important;
      border-color: #fff !important;
      font-size: 1.2rem !important;
      padding: 8px;
      height: auto;
    }
  }
}
</style>
